import { Point } from './Point'

const findIndexFrom = (list, index, f) => {
	if (index < 0)
		return -1

	for (; index < list.length; ++index) {
		if (f(list[index]))
			return index
	}

	return -1
}

const findIndexLast = (list, f) => {
	for (let i = list.length - 1; i >= 0; --i) {
		if (f(list[i]))
			return i
	}

	return -1
}

const getBorderBreaks = (graph, border, top) => {

	const getBreak = (first_break) => {
		if (first_break === 0)
			return 0
		const dx = graph[first_break].x - graph[first_break - 1].x
		const dy = graph[first_break].y - graph[first_break - 1].y
		const m = dy / dx

		const x = (border - graph[first_break - 1].y) / m

		return graph[first_break - 1].x + x
	}

	let breaks = []

	let first_break = 0
	let last_break = 0

	while (true) {
		if (top)
			first_break = findIndexFrom(graph, last_break, p => p.y > border)
		else
			first_break = findIndexFrom(graph, last_break, p => p.y < border)

		if (top)
			last_break = findIndexFrom(graph, first_break, p => p.y < border)
		else
			last_break = findIndexFrom(graph, first_break, p => p.y > border)

		if (first_break === -1)
			return breaks

		let start = getBreak(first_break)
		let end = 9

		if (last_break !== -1)
			end = getBreak(last_break)

		breaks.push([start, end])
	}
}

const insertPointOnLine = (graph, x) => {
	let nearest = graph.findIndex(p => p.x > x) - 1
	let is_end = false
	let dx = 0
	let dy = 0

	if (nearest === -2) {
		is_end = true
		nearest = graph.length - 2
	}

	dx = graph[nearest + 1].x - graph[nearest].x
	dy = graph[nearest + 1].y - graph[nearest].y

	const r = (dx**2 + dy**2)**0.5

	const alpha = Math.acos(dx / r)

	const ndx = x - graph[nearest].x
	const point = Point(x, graph[nearest].y)

	if (dy > 0) {
		point.y += Math.tan(alpha) * ndx
	} else {
		point.y -= Math.tan(alpha) * ndx
	}

	if (is_end) {
		graph.push(point)
	} else {
		graph.splice(nearest + 1, 0, point)
	}

	return graph
}

const setSectionTo = (graph, from, to, value) => {
	let begin = findIndexLast(graph, p => p.x === from)
	let end = graph.findIndex(p => p.x === to)

	if (end === -1) {
		graph = insertPointOnLine(graph, to)
	}

	if (begin === -1) {
		graph = insertPointOnLine(graph, from)
		begin = findIndexLast(graph, p => p.x === from)
		graph.splice(begin + 1, 0, Point(from, value))
	} else {
		if (begin > 0 && graph[begin - 1].x === from) {
			graph[begin].y = value
		} else {
			graph.splice(begin + 1, 0, Point(from, value))
		}
	}

	if (end === -1) {
		end = graph.findIndex(p => p.x === to)
		graph.splice(end, 0, Point(to, value))
	} else {
		if (end < graph.length - 1 && graph[end + 1].x === to) {
			graph[end].y = value
			graph.splice(end + 1, 0, Point(to, value))
		} else {
			graph.splice(end, 0, Point(to, value))
		}
	}


	graph = graph.filter(p => p.x <= from || p.x >= to)

	return graph
}

export { getBorderBreaks, insertPointOnLine, setSectionTo }
